import { useContext } from "react";
import { BalanceContext, FrbBalanceContext} from "@/src/context";

export const useBalances = () => useContext(BalanceContext);
export const useFrbBalances = () => useContext(FrbBalanceContext);